<template>
    <div>
        <div class="body--secondary__wrapper mb--md  animated fadeIn">
            <header class="header">
                <div class="container">
                    <div class="row align-items--center">
                        <div class="col-2">
                            <a @click.prevent="handleBack('/')" class="btn btn--icon btn--white">
                                <i class="material-icons">keyboard_arrow_left</i>
                            </a>
                        </div>
                        <div class="col-8">
                            <h1 class="header__title">Profile</h1>
                        </div>
                    </div>
                </div>
            </header>

            <section class="card card--expanded avatar-wrapper pb--30">
                <div class="container">
                    <div class="profile profile--vertical mb--30">
                        <figure class="profile__avatar">
                            <span class="profile__avatar__img">
                                <img :src="user.avatar" v-if="isLoggedIn" />
                                <img src="/img/pictures/avatar-1.jpg" v-else />
                            </span>

                            <a href="#edit-profile" v-bind:class="{'btn--disabled' : ! isLoggedIn}" class="btn btn--icon btn--white btn--left"><i class="material-icons">edit</i></a>
                            <a href="#game-settings" class="btn btn--icon btn--white btn--right"><i class="material-icons">settings</i></a>
                        </figure>

                        <div class="profile__text" v-if="isLoggedIn">
                            <div class="profile__name">{{ user.nick || 'Guest' }}</div>
                            <div class="profile__level">
                                <strong>Level {{ user.level }}</strong>
                            </div>
                        </div>
                        <div class="profile__text" v-else>
                            <div class="profile__name">Guest</div>
                            <div class="profile__level">
                                <strong>Level 1</strong>
                            </div>
                        </div>
                    </div>

                    <ul class="counter counter--light mb--20" v-if="isLoggedIn && stats">
                        <li>
                            <span class="counter__title">Games</span>
                            <div class="counter__number">{{ stats.total_games }}</div>
                        </li>
                        <li>
                            <span class="counter__title">Won</span>
                            <div class="counter__number">{{ stats.won }}</div>
                        </li>
                        <li>
                            <span class="counter__title">Won %</span>
                            <div class="counter__number">{{ stats.wonRate }}</div>
                        </li>
                    </ul>

                    <div class="row" v-if="isLoggedIn">
                        <div class="col-8 offset-2">
                            <router-link to="/profile/history" class="btn btn--block btn--sm btn--secondary">
                                Show full history
                            </router-link>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-8 offset-2">
                            <p class="text--center mb--lg">Login now to change your details and save results.</p>

                            <a href="login" class="btn btn--block btn--primary">Login</a>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <section class="container  animated fadeIn">
            <article class="card mb--md" v-if="isLoggedIn">
                <h2 class="card__title" id="edit-profile">
                    <i class="material-icons">edit</i> Edit profile
                </h2>

                <a class="option-item mb--lg">
                    E-mail
                    <span class="option-item__description">{{ user.email }}</span>
                </a>

                <a class="option-item pointer mb--lg" @click="openAvatarSelector">
                    Avatar

                    <avatar-selector-modal ref="avatarSelectorModal"></avatar-selector-modal>

                    <i class="option-item__icon material-icons">keyboard_arrow_right</i>
                </a>

                <div class="option-item pr--0 mb--0" v-if="user.unlockedAchievements == 5">
                    <div class="mb--md">Profile color</div>

                    <div class="row">
                        <div class="col-6">
                            <label for="color-pink" class="chooser chooser--pink mb--0">
                                <input type="radio" name="color-profile" id="color-pink" value="pink" v-model="profileColor" />

                                <i class="material-icons chooser__icon">check</i>
                            </label>
                        </div>

                        <div class="col-6">
                            <label for="color-blue" class="chooser chooser--blue mb--0">
                                <input type="radio" name="color-profile" id="color-blue" value="blue" v-model="profileColor" />

                                <i class="material-icons chooser__icon">check</i>
                            </label>
                        </div>
                    </div>
                </div>
            </article>

            <article class="card mb--lg">
                <h2 class="card__title" id="game-settings">
                    <i class="material-icons">settings</i>
                    Game settings
                </h2>

                <div class="option-item mb--lg">
                    Animations
                    <label for="animations" class="option-item__icon toggle">
                        <input type="checkbox" name="animations" id="animations" v-model="animation" />

                        <span class="toggle__bg">
                            <span class="toggle__handle"></span>
                        </span>
                    </label>
                </div>

            </article>

            <div class="row mb--lg" v-if="isLoggedIn">
                <div class="col-8 mx--auto">
                    <a @click="logout" class="btn btn--block btn--white">Logout</a>
                    <form action="/logout" method="post" ref="logout">
                        <div v-html="csrfField()"></div>
                    </form>
                </div>
            </div>

            <ul class="list text--center mb--lg opacity--sm">
                <li><a href="mailto:martin@quiz42.com">Contact us</a></li>
                <li><router-link to="/article/data-protection">Privacy Policy</router-link></li>
            </ul>
        </section>

        <navigation></navigation>
    </div>
</template>

<script>
    import Navigation from "../partial/Navigation";
    import {mapActions, mapGetters} from 'vuex'
    import internalBackRoute from "../../mixins/internalBackRoute";
    import authApi from "../../api/auth"

    export default {
        name: "Profile",
        components: {Navigation},
        mixins: [internalBackRoute],

        data: function () {
            return {
                stats: null
            }
        },

        methods: {
            ...mapActions('auth', [
                'setUserData',
                'setUserAvatar',
                'loadUser'
            ]),
            logout() {
                this.$refs.logout.submit();
            },
            openAvatarSelector() {
                this.$refs.avatarSelectorModal.open()
            },
        },
        computed: {
            ...mapGetters('auth', [
                'user',
                'isLoggedIn',
                'preferences'
            ]),
            animation: {
                get() {
                    if (!this.isLoggedIn) {
                        let animation = Cookies.get('quiz-animation');
                        if (typeof animation == 'undefined') {
                            return true;
                        }

                        return animation;
                    }

                    return this.$store.state.auth.user.animation;
                },
                set(value) {
                    this.$store.commit('auth/updatePreferences',  { field: 'animation', value: value})
                    if (!this.isLoggedIn) {
                        if (value) {
                            Cookies.set('quiz-animation', value, 1);
                            return;
                        }

                        Cookies.remove('quiz-animation');
                        return;
                    }
                    this.setUserData({field: 'animation', value});
                }
            },
            profileColor: {
                get() {
                    return get(this.$store.state.auth.user, 'profileColor', 'pink');
                },
                set(value) {
                    this.$store.commit('auth/updatePreferences',  { field: 'profileColor', value: value})
                    this.setUserData({field: 'profileColor', value});
                }
            }
        },

        created() {
            authApi.loadStat()
                .then((response) => {
                    this.stats = response.data
                })

            this.$store.dispatch('auth/loadUser')
            Quiz.$on('update-user-avatar', (value) => this.setUserAvatar(value))
        },

        mounted() {
            $('body').addClass('body--secondary')
        },

        beforeDestroy() {
            $('body').removeClass('body--secondary')
            Quiz.$off('update-user-avatar')
        }
    }
</script>